import { CardProps } from '../types/components'
import Button from './Button'

function Card({ type, icon, title, isActive = false, isButtonHidden = false, onClick }: CardProps) {

    if (type === 'services')
        return (
            <div onClick={onClick} className={`group rounded-[14px] z-10 p-4 md:p-6 xl:py-8 3xl:px-12 3xl:pt-16 3xl:pb-14 shadow-xl flex sm:flex-col sm:space-y-8 transition-all duration-300 cursor-pointer ${isActive ? 'bg-themeOrange text-white' : 'bg-white hover:bg-themeOrange hover:text-white'}`}>
                <div className={`min-w-[5.5rem] sm:min-h-[4rem] xl:min-h-[6.5rem] 3xl:min-h-[10rem] flex justify-center sm:justify-start pr-4 transition-all duration-300 ${isActive ? `${title?.toLowerCase() === "development" ? "text-themeOrange" : "text-white"}` : `text-[#28293E] ${(title?.toLowerCase() === "development" || title?.toLowerCase() === "compassionate") ? 'group-hover:text-themeOrange' : 'group-hover:text-white'}`}`}>
                    {icon}
                </div>
                <div className="">
                    <div className={`${isActive ? 'text-white' : 'text-themeOrange group-hover:text-white'} transition-all duration-300 font-bold sm:text-lg md:text-xl xl:text-[1.75rem] xl:leading-tight 3xl:text-4xl`}>{title}</div>
                    <div className="text-xs sm:text-sm xl:text-[1.375rem] xl:leading-8 3xl:text-[2rem] 3xl:leading-10 mt-1.5 sm:mt-3 md:mt-4">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    </div>
                    {
                        isButtonHidden &&
                        <div className="hidden xl:block xl:pt-11 mt-1.5 sm:mt-3 md:mt-4">
                            <Button transparent buttonClass={`!text-themeOrange bg-white ${isActive ? 'ring-white' : 'group-hover:ring-white'}`} borderClass={isActive ? "ring-white" : "ring-themeOrange group-hover:ring-white"}>Know More</Button>
                        </div>
                    }
                </div>
            </div>
        )
    if (type === 'large')
        return (
            <div onClick={onClick} className={`group shadow-lg xl:shadow-2xl rounded-[14px] z-10 py-6 pl-8 pr-16 transition-all duration-300 cursor-pointer ${isActive ? 'bg-themeOrange text-white' : 'bg-white hover:bg-themeOrange hover:text-white'}`}>
                <div className="flex items-center">
                    <div className={`min-h-[5rem] flex items-center justify-center mr-5 transition-all duration-300 ${isActive ? `${title?.toLowerCase() === "development" ? "text-themeOrange" : "text-white"}` : `text-[#28293E] ${(title?.toLowerCase() === "development" || title?.toLowerCase() === "compassionate") ? 'group-hover:text-themeOrange' : 'group-hover:text-white'}`}`}>
                        {icon}
                    </div>
                    <div className={`text-4xl font-bold ${isActive ? 'text-white' : 'text-themeOrange group-hover:text-white'} transition-all duration-300 `}>{title}</div>
                </div>
                <div className="mt-5">
                    <div className="text-base opacity-80">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    </div>
                </div>
            </div>
        )

    return <></>
}

export default Card